<template>
	<b-overlay no-center :show="isOverlayDisplayed" :opacity="overlayOpacity" :class="!loadIframe ? 'overflow-hidden' : 'overflow-auto'" class="w-100 h-100">
		<!-- <b-embed type="iframe" ref="iframeCenter" name="iframeCenter" id="iframeCenter" :src="iframeTarget" @load="iframeLoaded" v-if="loadIframe" /> -->
		<b-row class="h-100 w-100">
			<b-col class="h-100 w-100">
				<!-- :style="spanResizing désactive les events dans l'IFrame lorsque le splitpanes est déplacé dans Workbench.vue
					==> les events Ext.net/DCx V2 de l'IFrame interférant avec les events de DCXClient -->
				<iframe v-if="loadIframe" ref="iframeCenter2" name="iframeCenter2" id="iframeCenter2" :src="iframeTarget" loading="lazy" 
					@load="iframeLoaded"
					@mouseenter="sessionUtils.CheckExpirationSession($event)"
					@mouseleave="sessionUtils.CheckExpirationSession($event)"
					class="h-100 w-100 m-0 border-0 block position-absolute" 
					:style="SpanResizing ? 'pointer-events: none;' : ''" />
			</b-col>
		</b-row>

		<!-- Overlay customisé -->
		<template #overlay >
			<!-- Affichage d'un message si aucun noeud n'a été sélectionné -->
			<Welcome v-if="displayedOverlay === overlayEnum.SingleNodeSelection" :DisplayBrand="false" :Variant="Variant">
				<!-- Suppression message de bienvenue par défaut-->
                <template v-slot:MiscContent>
					<!-- $t('PleaseSelectObjectInTreeStructure') / Veuillez sélectionner un objet dans l'arborescence -->
					<h4 class="text-center">{{ $t('PleaseSelectObjectInTreeStructure') }}</h4>
                </template>
			</Welcome>
			<!-- Overlay de chargement de l'IFrame-->
			<Welcome v-if="displayedOverlay === overlayEnum.Loading" :DisplayBrand="false" :Loading="true" :Variant="Variant" />
		</template>
	</b-overlay>
</template>

<script lang="ts">
	import { Prop, Vue, Watch } from 'vue-property-decorator';
	import Component, { mixins } from 'vue-class-component';
	import { DCX_SYNC_SESSION_EXPIRATION_DELAY, DCX_URL } from '@/App.settings';
	import OverlayEnum from "@/enums/OverlayEnum";
	import { OverlayUtils, SessionUtils } from '@/components/commons/Utils';
	import Welcome from '@/components/commons/Welcome.vue';
	import locales from './locales/IFrameLoader.json';
import { Getter } from 'vuex-class';

	/** Composant spécifique pour affichage IFrame de fonctions d'administration de la V2 */
	@Component({
        components: {
            Welcome
        },
		i18n: {messages: locales}
    })
	export default class IFrameLoader extends mixins(OverlayUtils) {
		/** Pour permettre l'utilisation des enums dans la section template */
		private overlayEnum = OverlayEnum;
		/** Pour vérification expériation de session */
		private sessionUtils: SessionUtils = new SessionUtils(this.$cookies, this.$router);

		/** Variant de couleurs à appliquer */
        @Prop()
        public Variant!:string;

		/** Nom Fonction d'administration */
		@Prop()
		public Interop!: string;

		/** Fonction d'administration V2 à charger  */
		@Prop()
		public Link!: string;

		/**
		 * Utilisé pour désactiver les events dans l'IFrame lorsque le splitpanes est déplacé dans Workbench.vue
					==> les events Ext.net/DCx V2 de l'IFrame interférant avec les events de DCXClient
		 */
		@Prop()
		public SpanResizing!: boolean;

		/** Chemin complet */
		private iframeTarget: string = "";
		private loadIframe: boolean = false;

		private iframeLoaded() {
			this.hideOverlay();
		}

		@Getter('SessionStore/GetLastSync')
		private lastSync!: number; 

		/** Chargement de l'url passé dans la Prop Link */
		@Watch("Link", { immediate: true })
		private async GetFeatureInterop() {
			this.displayOverlay(OverlayEnum.Loading);

			Vue.set(this, "loadIframe", false);

			let ik = undefined;
			if((Date.now() - this.lastSync) > DCX_SYNC_SESSION_EXPIRATION_DELAY)
				ik = await this.$store.dispatch('SessionStore/RefreshSync');
			else
				this.$store.dispatch('SessionStore/SetSync')

			let url: string = DCX_URL + this.Link + "?interop=" + this.Interop + (ik !== undefined ? '&lk=' + ik : '');

			Vue.set(this, "iframeTarget", url);
			console.debug("IFrameLoader - GetFeatureInterop() - url : " + this.iframeTarget);

			Vue.set(this, "loadIframe", true);
		}

		beforeDestroy() {
			/** Nettoyage du sessionUtils */
			if (this.sessionUtils) {
				this.sessionUtils.destroy();
			}
			// On vide la variable du composant
			(this as any).sessionUtils = null;
		}
	}
</script>

<style scoped>

</style>